module.exports = __webpack_public_path__ + "media/images/common/ico-thumbnail-70462d262af6365f1b581c52f652c132.svg";